module.exports = __webpack_public_path__ + "static/media/sweet_alchemy.playngo.258ed418.jpeg";